<template>
    <div class="row">
        <div v-for="(integrationInformation,index) in value.IntegrationInformationParams" :key="index" class="col-12 mb-1">
            <label class="form-label">{{integrationInformation.VisibleName}}</label>
            <input type="text" class="form-control" placeholder="" v-model="integrationInformation.Value"/>
        </div>
        
    </div>
</template>

<script>
import { BFormCheckbox } from 'bootstrap-vue'

export default {
    components:{
        BFormCheckbox
    },
    props:{
        value:Object
    },
}
</script>

<style lang="scss">
</style>